import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import BASE_URL from "../../BASEURL";

export default function PaymentSettings() {
  const [convenienceFee, setConvenienceFee] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      // Depending on auth, might need to pass token here.
      const res = await fetch(`${BASE_URL}/api/admin/settings/payment`);
      const data = await res.json();
      if (res.ok) {
        setConvenienceFee(data.convenienceFee);
      }
    } catch (error) {
      console.error("Failed to fetch settings:", error);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/api/admin/settings/payment`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${token}` if needed
        },
        body: JSON.stringify({ convenienceFee: Number(convenienceFee) }),
      });
      const data = await res.json();
      
      if (res.ok) {
        toast.success(data.message || "Settings updated successfully");
      } else {
        toast.error(data.message || "Failed to update settings");
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Server error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="max-w-2xl bg-white rounded-xl shadow-sm border p-4 sm:p-8">
      <h1 className="text-2xl font-bold mb-6">Payment Settings</h1>
      
      <form onSubmit={handleSave} className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Online Payment Convenience Fee (%)
          </label>
          <div className="relative">
            <input
              type="number"
              min="0"
              step="0.01"
              value={convenienceFee}
              onChange={(e) => setConvenienceFee(e.target.value)}
              className="w-full border-gray-300 rounded-lg p-3 border focus:ring-orange-500 focus:border-orange-500"
              placeholder="e.g. 2"
              required
            />
            <span className="absolute right-4 top-3.5 text-gray-500 font-bold">%</span>
          </div>
          <p className="text-sm text-gray-500 mt-2">
            This percentage will be automatically added to the customer's total amount during Razorpay checkout.
          </p>
        </div>

        <button
          type="submit"
          disabled={isLoading}
          className="bg-orange-600 text-white px-6 py-2 rounded-lg font-bold hover:bg-orange-700 transition disabled:opacity-50"
        >
          {isLoading ? "Saving..." : "Save Settings"}
        </button>
      </form>
    </div>
  );
}
